import { useState } from "react";
import AuthFormPanel from "./AuthFormPanel";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import { useAuth } from "../Hooks/useAuth";

/**
 * Header-right auth widget: "Registrati"/"Accedi" when logged out, or a
 * greeting + "Esci" when logged in. Entirely self-contained (owns its own
 * `useAuth()` instance) so `MainLayout` stays a one-line diff.
 */
export default function AuthControls() {
    const { user, ready, login, register, logout } = useAuth();
    const [openPanel, setOpenPanel] = useState<"login" | "register" | null>(null);

    if (!ready) return null;

    if (user) {
        return (
            <div className="flex items-center gap-3">
                <span className="hidden text-sm text-gray-600 dark:text-gray-300 sm:inline">
                    Ciao, {user.username}
                </span>
                <SecondaryButton
                    type="button"
                    className="px-3 py-1.5 text-xs"
                    onClick={() => {
                        void logout();
                    }}
                >
                    Esci
                </SecondaryButton>
            </div>
        );
    }

    return (
        <div className="relative flex items-center gap-2">
            <SecondaryButton
                type="button"
                className="px-3 py-1.5 text-xs"
                onClick={() => setOpenPanel((p) => (p === "register" ? null : "register"))}
            >
                Registrati
            </SecondaryButton>
            <PrimaryButton
                type="button"
                className="px-3 py-1.5 text-xs"
                onClick={() => setOpenPanel((p) => (p === "login" ? null : "login"))}
            >
                Accedi
            </PrimaryButton>

            {openPanel && (
                <AuthFormPanel
                    mode={openPanel}
                    onClose={() => setOpenPanel(null)}
                    onSubmit={(username, password, rememberMe) =>
                        openPanel === "login"
                            ? login(username, password, rememberMe)
                            : register(username, password)
                    }
                />
            )}
        </div>
    );
}
